/*
 *
 * SalesforceVerify actions
 *
 */
import { VERIFY_SALESFORCE } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifySalesforce = {
  start: ({ payload, metadata }) =>
    defineAction({ type: VERIFY_SALESFORCE.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_SALESFORCE.SUCCESS });
  },
  error: ({ error }) =>
    defineAction({
      type: VERIFY_SALESFORCE.ERROR,
      payload: {
        error,
      },
    }),
};
